<template>
 <div class="row machine-select" v-if="isDataLoaded">
    <div class="col" v-if="machinesData.length > 0">
            <div class="row">
                 <div class="col mx-2">
                    <h2 class="ml-2">Выбор печатной машины</h2>
                 </div>
            </div>
            <div class="row mt-4">
              <div class="col-6 mx-2">
                <div class="input-group with-clear-icon">
                  <input type="text" class="form-control" v-model="searchText">
                  <i class="ico ico-close" @click="clearSearchText" v-if="searchText.length > 0"></i>
                  <div class="input-group-append">
                    <span class="input-group-text">
                      <i class="fa fa-search"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
                 <div class="col mx-2">
                    <div class="d-flex flex-wrap py-2 justify-content-start">
                        <div class="card mr-2" v-for="machine in machines"
                        :class="{'card--red': !machine.enabled}"
                        :key="machine.id"
                        @click="selectMachine(machine.id)">
                            <div class="card-header">
                                <h5 :title="machine.name">{{machine.name.toUpperCase()}}</h5>
                            </div>
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item d-flex justify-content-between">
                                    <span>Формат печати:</span>
                                    <b>{{machine.printWidth}}x{{machine.printHeight}} мм</b>
                                </li>
                            </ul>
                        </div>
                    </div>
                 </div>
            </div>
    </div>
    <div class="col machine-select--empty" v-else>
      <div class="d-flex justify-content-end">
        <div class="d-flex flex-column align-items-center justify-content-center">
          <h2 class="text-center mt-5">На данный момент у вас нет активных печатных машин</h2>
          <button type="button" class="btn btn-primary mt-3" @click="$router.push(`/settings/print-machines`)">
              настроить печатные машины
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../../api'
import roles from '../../../helpers/userRoles'
import _ from 'lodash'
export default {
  name: 'CalculateMachineSelect',
  components: {},
  data: () => {
    return {
      machinesData: [],
      searchText: '',
      isDataLoaded: false
    }
  },
  computed: {
    machines () {
      let result = this.machinesData
      if (this.searchText) {
        result = result.filter(
          x => x.name.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0
        )
      }
      return result
    },
    isAddAgent () {
      return this.$store.getters.role === roles.adAgent
    }
  },
  methods: {
    selectMachine (machineId) {
      if (this.machinesData.find(x => x.id === machineId).enabled) {
        if (this.isAddAgent) {
          this.$router.push(`/ad-agent/calculate/product-select/${machineId}`)
        } else {
          this.$router.push(`/calculate/product-select/${machineId}`)
        }
      }
    },
    clearSearchText () {
      this.searchText = ''
    }
  },
  created () {
    api.get.printMachines().then(resp => {
      this.machinesData = _.sortBy(resp.data.data.printMachines, x => { return x.name })
    }).finally(() => {
      this.isDataLoaded = true
    })
  }
}
</script>

<style lang="scss" scoped>
.machine-select {

  &--empty {
    min-height: calc(100vh - 100px);
  }

  .card {
    width: 300px !important;
    margin-top: 10px;
    border-color: #28bd8b;
    cursor: pointer;

    .card-header {
      color: #fff;
      background-color: #28bd8b;
      height: 100px;
      box-sizing: border-box;
      overflow: hidden;

      h5 {
        text-overflow: ellipsis;
        margin: 0;
      }
    }

    &:hover {
      border-color: #1d8864;

      .card-header {
        background-color: #1f936c;
        border-color: #1d8864;
      }

      .list-group-item {
        border-color: #1d8864;
      }
    }

    &--red {
      cursor: default;
      border-color: #f34d65;
      &:hover {
        border-color: #f34d65;

        .card-header {
          background-color: #f34d65;
          border-color: #f34d65;
        }

        .list-group-item {
          border-color: #f34d65;
        }
      }
      .card-header {
        background-color: #f34d65;
      }
    }
  }
}
</style>
